import React, { useEffect, useRef, useState } from "react";
import { FaGithub, FaLinkedin } from "react-icons/fa";
import { FaSquareXTwitter } from "react-icons/fa6";
import { HiOutlineMail } from "react-icons/hi";

const SocialLinks = () => {
  const [expanded, setExpanded] = useState(false);
  const dockRef = useRef(null);
  const links = [
    {
      id: 1,
      label: "LinkedIn",
      icon: <FaLinkedin />,
      href: "https://www.linkedin.com/in/vijay-a-ba3886259/",
    },
    {
      id: 2,
      label: "GitHub",
      icon: <FaGithub />,
      href: "https://github.com/Vijay-Hozo",
    },
    {
      id: 3,
      label: "Email",
      icon: <HiOutlineMail />,
      href: "mailto:personal@avijay.tech",
    },
    {
      id: 4,
      label: "X / Twitter",
      icon: <FaSquareXTwitter />,
      href: "https://x.com/mr_vijay_a_",
    },
  ];

  useEffect(() => {
    const closeOnOutsideClick = (event) => {
      if (dockRef.current && !dockRef.current.contains(event.target)) {
        setExpanded(false);
      }
    };
    const closeOnEscape = (event) => {
      if (event.key === "Escape") setExpanded(false);
    };
    document.addEventListener("pointerdown", closeOnOutsideClick);
    document.addEventListener("keydown", closeOnEscape);
    return () => {
      document.removeEventListener("pointerdown", closeOnOutsideClick);
      document.removeEventListener("keydown", closeOnEscape);
    };
  }, []);

  return (
    <div ref={dockRef} className="social-dock fixed bottom-5 left-1/2 z-40 -translate-x-1/2">
      <div className={`social-dock-shell ${expanded ? "social-dock-expanded" : ""}`}>
        <button
          type="button"
          aria-expanded={expanded}
          aria-label={expanded ? "Collapse social links" : "Expand social links"}
          onClick={() => setExpanded((isExpanded) => !isExpanded)}
          className="social-dock-toggle"
        >
          <span />
          <span />
          <span />
        </button>
        <ul className="social-dock-links">
          {links.map(({ id, label, icon, href }) => (
            <li key={id} className="social-dock-item">
              <a href={href} target="_blank" rel="noopener noreferrer" aria-label={label}>
                <span className="social-dock-icon">{icon}</span>
                <span className="social-dock-label">{label}</span>
              </a>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default SocialLinks;
